import "./Modals.scss";
import { useState } from "react";
import axios from "axios";
import countries from "./countries.json";

const TextInput = ({ inputTitle, inputPlaceholder, value, setValue, type, hint = false, error = false }) => {
  return (
    <div className="inputContainer">
      <p className="inputTitle">{inputTitle}</p>
      <input
        className={error ? "errorInput" : "regularInput"}
        type={type}
        placeholder={inputPlaceholder}
        value={value}
        onChange={(e) => setValue(e?.target?.value)}
      />
      <p className="hint">{hint}</p>
      <p className="errorText">{error}</p>
    </div>
  );
};

const DateOfBirthInput = ({ inputTitle, hint = false, error = false, dob, setDob }) => {
  // Calculate the max date (18 years ago)
  const getMaxDate = () => {
    const today = new Date();
    const maxYear = today.getFullYear() - 18;
    return `${maxYear}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;
  };

  return (
    <div className="inputContainer">
      <p className="inputTitle">{inputTitle}</p>
      <input
        className={error ? "errorInput" : "regularInput"}
        type="date"
        value={dob}
        onChange={(e) => setDob(e.target.value)}
        max={getMaxDate()}
      />
      {hint && <p className="hint">{hint}</p>}
      {error && <p className="errorText">{error}</p>}
    </div>
  );
};

const CountrySelector = ({ dialCode, setDialCode }) => {
  const handleSelectChange = (event) => {
    setDialCode(event.target.value);
  };

  return (
    <div>
      <select onChange={handleSelectChange}>
        {countries.map((country, index) => (
          <option className="countryName" key={index} value={country.dial_code}>
            {country.flag} {country.name}
          </option>
        ))}
      </select>
    </div>
  );
};

const PhoneInput = ({ dialCode, setDialCode, phoneNumber, setPhoneNumber }) => {
  const handleChange = (event) => {
    const newValue = event.target.value.replace(/[^\d]/g, "").slice(0, 12);
    setPhoneNumber(newValue);
  };

  return (
    <div className="phoneInputScreen">
      <p className="inputTitle">Your Phone</p>
      <div className="phoneInputBlock">
        <div className="countryRow">
          <CountrySelector dialCode={dialCode} setDialCode={setDialCode} />
        </div>

        <div className="phoneNumberRow">
          <span className="countryCodeText">{dialCode}</span>

          <input
            type="phone"
            className="phoneNumberText"
            value={phoneNumber}
            placeholder="--- ---- ----"
            onChange={(e) => {
              handleChange(e);
            }}
          />
        </div>
      </div>
    </div>
  );
};

export { TextInput, PhoneInput, DateOfBirthInput };
